import { promiseObject } from '../promise-proxies';
export default function promiseRecord(store, promise, label) {
  let toReturn = promise.then(identifier => store.peekRecord(identifier));
  return promiseObject(toReturn, label);
}